module.exports = __webpack_public_path__ + "static/media/girl-10.ceb1bf20.svg";